"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sassofeltrio": {
    "8ab6bd15": [{
      "hkey": "4757048c",
      "slug": "farneto",
      "name": "Farneto",
      "primary": true,
      "skipSearch": false
    }],
    "fameto": [{
      "hkey": "4757048c",
      "slug": "farneto",
      "name": "Farneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;